function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "sIs7",
  x1: 0.5,
  x2: 0.5,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ff9ea6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ff72a9"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.787 3.078)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 35,
  height: 48,
  transform: "translate(-1.787 -3.078)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13762.592,16202.375l-11.248-11.25-11.21,11.211a2.643,2.643,0,0,1-3.736-3.74l11.206-11.211-11.206-11.207a2.643,2.643,0,1,1,3.736-3.74l11.21,11.205,11.248-11.248a2.644,2.644,0,0,1,3.74,3.738l-11.247,11.252,11.247,11.246a2.646,2.646,0,1,1-3.74,3.744Z",
  transform: "translate(-13735.619 -16166.496)",
  fill: "url(#sIs7)"
}));

function SvgCloseActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 48,
    viewBox: "0 0 35 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseActive);
export default __webpack_public_path__ + "static/media/close-active.1f3b75a0.svg";
export { ForwardRef as ReactComponent };